import { createContext } from 'react';

const ContextMain = createContext({
    imageUserBox: {},
    setImageUserBox: () => {},
});

export default ContextMain; 